import { CheckoutOnline } from '@templates/Checkout/CheckoutOnline.ui';
import { GetServerSideProps } from 'next';
import { QueryClient } from 'react-query';
import { dehydrate } from 'react-query/hydration';
import getPaymentTokenizationKey from '@olo-web/services/payments/getPaymentTokenizationKey';
import { getOrder } from '@olo-web/services/emagine/getOrder';
import { getMerchant } from '@olo-web/services/emagine/getMerchant';
import { configureMerchantData } from '@domain/merchants/functions/configureMerchantData';
import { v4 as uuid } from 'uuid';
import { ldCookieOptions, getFeatureFlags } from '@olo-web/services/launchDarkly';
import nookies from 'nookies';
import { ECookies } from '@olo-web/types/enums';
import { ECheckoutTypes } from '@olo-web/types/enums/checkoutTypes.enum';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  try {
    const { merchantId, orderId } = ctx.query;
    const checkoutType = ctx.query.checkoutType as string;
    const cookie = nookies.get(ctx);
    const userKey = cookie[ECookies.ldUserKey] || uuid();
    if (!cookie[ECookies.ldUserKey]) nookies.set(ctx, ECookies.ldUserKey, userKey, ldCookieOptions);

    const queryClient = new QueryClient();

    const promises = [
      queryClient.prefetchQuery(
        ['payment-tokenization-key', merchantId],
        // @ts-ignore
        async () => {
          try {
            const { data } = await getPaymentTokenizationKey({ merchantId });
            return data;
          } catch (e) {
            return null;
          }
        }
      ),
    ];

    if (checkoutType === ECheckoutTypes.SPLIT_BY_AMOUNT) {
      //When the user is sent directly to checkout (currently only happens for SBA) we need to fetch the order and merchant so that it loads properly

      if (orderId) {
        const orderPrefetch = queryClient.prefetchQuery(
          ['order', merchantId, orderId],
          async () => {
            try {
              const { data } = await getOrder(merchantId, orderId as string);
              return data;
            } catch (e) {
              return null;
            }
          }
        );
        promises.push(orderPrefetch);
      }

      const merchantPrefetch = queryClient.prefetchQuery(
        ['merchant', merchantId],
        // @ts-ignore
        async () => {
          const { data } = await getMerchant(merchantId as string);
          const merchant = configureMerchantData(data);
          return merchant;
        }
      );
      const featureFlagPrefetch = queryClient.prefetchQuery(
        ['feature-flags', userKey],
        // @ts-ignore
        async () => {
          try {
            const featureFlags = await getFeatureFlags(userKey, merchantId as string, '');
            return featureFlags;
          } catch (e) {
            return null;
          }
        }
      );
      promises.push(merchantPrefetch, featureFlagPrefetch);
    }

    await Promise.all(promises);

    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
    };
  } catch (e) {
    if (e?.response?.status === 404) {
      return {
        notFound: true,
      };
    }
    throw e;
  }
};

export default CheckoutOnline;
